import type React from "react";
import type {ReactNode} from "react";
import {PageHeader} from "~/components/main/header/PageHeader";

type Props = {
    /** Back to the gallery, from the "Dashboards" link in the app's top bar. */
    onBack: () => void;
    /** The dashboard's name, after the back link; left out while it loads. */
    title?: string;
    children: ReactNode;
};

/**
 * The page panel's dashboard view, in the gallery (a dashboard Atlas just built) and on the dashboard
 * page. Like Supplier 360, "← Dashboards / <dashboard name>" sits in the app's top bar.
 */
export const DashboardDetailLayout: React.FC<Props> = ({onBack, title, children}) => (
    <div className="dsh-root dsh-detail">
        <PageHeader back={{label: "Dashboards", onClick: onBack}} title={title}/>
        <div className="dsh-detail-body">{children}</div>
    </div>
);
